import type { ReactNode } from "react";
import { Card, CenteredPage, Wordmark } from "../ui";

/** The centred card every sign-in screen sits in: mark, title and intro. */
export const AuthCard = ({
  title,
  intro,
  before,
  children,
}: {
  title: string;
  intro: ReactNode;
  /** Shown above the card, such as a back button. */
  before?: ReactNode;
  children: ReactNode;
}) => (
  <CenteredPage>
    <div className="w-full max-w-md">
      {before}
      <Card variant="hero" className="w-full">
        <header className="mb-8 text-center">
          <Wordmark className="mb-6" />
          <h1 className="font-lora text-3xl font-semibold tracking-tight">{title}</h1>
          <p className="mt-3 text-sm leading-6 text-hazumu-muted">{intro}</p>
        </header>
        {children}
      </Card>
    </div>
  </CenteredPage>
);
